import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileSearchService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  search(searchTerm: string, folderId: string | null | undefined): Observable<any> {
    return this.#http.getData<any>(`${this.baseUrl}/search?searchTerm=${searchTerm}&folderId=${folderId ?? ''}`, {
      showLoader: false,
      showMessage: false,
      showError: false
    });
  }
}
